import React, { Component } from "react";
import axios from "axios";
import httpService from "./AxiosInterceptors";
import { authService } from "./auth";

httpService.setupInterceptors()

class ActivityCaptureModalPopUp extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userData: authService.getUserDetailsFromLocalStorage(),
            formData: {
                likeData: "",
                interest: "",
                lookingFor: "",
                questionList: [
                    { label: "Learning, News and updates in this field", value: "LEARNING_AND_NEWS", isChecked: false },
                    { label: "Networking & Community building", value: "NETWORKING_AND_COMMUNITY", isChecked: false },
                    { label: "Job opportunity", value: "JOB_OPPORTUNITY", isChecked: false },
                    { label: "Nature Content Creator & monetisation", value: "NATURE_CONTENT_AND_MONETISATION", isChecked: false },
                    { label: "Project management", value: "PROJECT_MANAGEMENT", isChecked: false },
                    { label: "Fund Raise & Contributions", value: "FUND_RAISE", isChecked: false }
                ]
            },
            errors: {}
        }
    }

    handleChange = (data, fieldName) => {
        data.persist();
        this.setState((prevState) => ({
            formData: { ...prevState.formData, [fieldName]: data?.target?.value?.trimStart() }
        }));
    }

    handleCheckedActivity = (event, data) => {
        let questionDataList = this.state?.formData?.questionList;
        let index = questionDataList?.findIndex((item) => item?.value === data?.value);
        if(index > -1) {
            questionDataList[index].isChecked = event?.target?.checked;
        }
        this.setState((prevState) => ({
            formData: { ...prevState.formData, questionList: questionDataList }
        }));
    };

    validate = () => {
        let errors = {};
        let formIsValid = true;
        if (!this.state.formData?.likeData) {
            formIsValid = false;
            errors["likeData"] = "Please enter what would you like to do";
        }
        if (!this.state.formData?.interest) {
            formIsValid = false;
            errors["interest"] = "Please enter what are your interests";
        }
        if (!this.state.formData?.lookingFor) {
            formIsValid = false;
            errors["lookingFor"] = "Please enter what are you looking for";
        }
        if (!this.state.formData?.questionList?.filter((question) => question?.isChecked)?.length === 0) {
            formIsValid = false;
            errors["questionList"] = "Please select at least one option";
        }
        this.setState({
            errors: errors,
        });
        setTimeout(() => {
            this.setState({
                errors: {}
            })
        }, 2000)
        return formIsValid;
    };

    handleSubmit = (e) => {
        e.preventDefault();
        //if (this.validate()) {
            let postData = {
                userId: this.state?.userData?.userId,
                interest: this.state?.formData?.interest,
                lookingFor: this.state?.formData?.lookingFor,
                likeData: this.state?.formData?.likeData,
                event: this.state?.formData?.questionList?.filter((question) => question?.isChecked)?.map((data) => data?.value)
            }
            axios({
                method: "POST",
                url: `${process.env.REACT_APP_userServiceURL}/activity/capture/save`,
                headers: { "Content-Type": "application/json" },
                data: postData,
                withCredentials: true,
            }).then((response) => {
                if(response?.data?.message === "Success!") {
                    this.props.onCloseActivityCaptureModal();
                }
            }).catch((err) => {

            });
        //}
    }

    componentWillUnmount() {
        window.$("#activityCaptureModal").modal("hide");
    }

    componentDidMount() {
        window.$("#activityCaptureModal").modal("show");
    }

    render() {
        const { formData, errors } = this.state;

        return (
            <div id="activityCaptureModal" className="modal fade dgpopup" data-backdrop="static" data-keyboard="false">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-body" style={{ maxWidth: "700px", width: "100%", margin: "auto" }}>
                            <div className="sProjectListPop datePart">

                                <h2>WeNAT: Know your User</h2>

                                <form action="javascript:void(0)" id={"enquireNowForm"} className="modform" onSubmit={this.handleSubmit}>
                                    <div className="row">
                                        <div className="col-md-12 col-xs-12">
                                            <div className="form-group">
                                                <input
                                                    type="text"
                                                    className="custom-input form-control"
                                                    autoComplete="given-name"
                                                    placeholder="What would you like to do"
                                                    value={formData?.likeData}
                                                    onChange={(e) => this.handleChange(e, "likeData")}
                                                />
                                                {errors["likeData"] && <span className="login-feedback-error mt-1" style={{ display: "block", width: "auto" }}>{errors["likeData"]}</span>}
                                            </div>
                                        </div>
                                        <div className="col-md-12 col-xs-12">
                                            <div className="form-group">
                                                <input
                                                    type="text"
                                                    className="custom-input form-control"
                                                    autoComplete="given-name"
                                                    placeholder="What are your interests"
                                                    value={formData?.interest}
                                                    onChange={(e) => this.handleChange(e, "interest")}
                                                />
                                                {errors["interest"] && <span className="login-feedback-error mt-1" style={{ display: "block", width: "auto" }}>{errors["interest"]}</span>}
                                            </div>
                                        </div>
                                        {/* <div className="col-md-12 col-xs-12">
                                            <div className="form-group">
                                                <input
                                                    type="text"
                                                    className="custom-input form-control"
                                                    autoComplete="given-name"
                                                    placeholder="What are you looking for"
                                                    value={formData?.lookingFor}
                                                    onChange={(e) => this.handleChange(e, "lookingFor")}
                                                />
                                                {errors["lookingFor"] && <span className="login-feedback-error mt-1" style={{ display: "block", width: "auto" }}>{errors["lookingFor"]}</span>}
                                            </div>
                                        </div> */}
                                        <div className="col-md-12 col-xs-12">
                                            <div className="form-group">
                                                <h3 style={{ fontWeight: "bold" }}>What are you looking for?</h3>
                                            </div>
                                        </div>
                                        
                                        {formData?.questionList?.map((question) => {
                                            return (
                                                <div className="col-md-6 col-xs-12">
                                                    <div className="d-flex mb-3 pb-2">
                                                        <div className="custom-control custom-checkbox">
                                                            <input type="checkbox" className="custom-control-input" id={question?.value} checked={question?.isChecked} onChange={(e) => this.handleCheckedActivity(e, question)} />
                                                            <label className="custom-control-label" for={question?.value}>{question?.label}</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })}
                                        {errors["questionList"] && <span className="login-feedback-error mt-1" style={{ display: "block", width: "auto" }}>{errors["questionList"]}</span>}
                                    </div>
                                    <div className="forwcontwrapbott justify-content-end" style={{ boxShadow: "none" }}>
                                        <div>
                                            <button type="submit" className="btn">{"Update"}</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default ActivityCaptureModalPopUp;